import styled from 'styled-components'

export const Label = styled.label<{ $disabled: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  position: relative;
  height: 40px;
  border-radius: 20px;
  line-height: 20px;
  cursor: pointer;
  color: ${props => props.theme.colors.white};
  opacity: ${props => (props.$disabled ? '0.2' : '1')};

  input {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: red;
    opacity: 0;
    cursor: pointer;
  }
`
